"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2234],{

/***/ 60581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTimes = function SvgTimes(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.197 14.457c.387.378 1.02.378 1.389.009L7.99 9.06l5.405 5.405a.992.992 0 0 0 1.39-.009.99.99 0 0 0 .008-1.38L9.389 7.663l5.405-5.405c.37-.37.378-1.01-.009-1.38a1 1 0 0 0-1.389-.009L7.991 6.274 2.586.87a1 1 0 0 0-1.389 0c-.378.387-.369 1.028 0 1.389l5.406 5.405-5.406 5.414a.99.99 0 0 0 0 1.38Z",
    fill: "#999"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgTimes);

/***/ }),

/***/ 14264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ AuthModal; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39097);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63955);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5632);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33052);
/* harmony import */ var react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17473);
/* harmony import */ var _foros_fe_graphql__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63575);
/* harmony import */ var _foros_fe_graphql__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33627);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27581);
/* harmony import */ var _Inputs_TextInput__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10809);
/* harmony import */ var _Inputs_CheckBox__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(76008);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36573);
/* harmony import */ var _Forms_Form__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48375);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58451);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75920);

















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "text-2xl text-center mb-6 font-medium"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "text-primary-500 hover:underline cursor-pointer"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Title = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().p(_templateObject());
var NavLink = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().span(_templateObject1());
var defaultValues = {
    terms: false,
    news: false,
    email: ''
};
var AuthModal = function(param) {
    var _open = param.open, open = _open === void 0 ? false : _open, onClose = param.onClose, _registration = param.registration, registration = _registration === void 0 ? false : _registration;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    var ref5 = _slicedToArray((0,_foros_fe_graphql__WEBPACK_IMPORTED_MODULE_9__/* .useCreateLeadUserMutation */ .SoK)(), 1), createLeadUserMutation = ref5[0];
    var registrationTypeQuery = (0,_foros_fe_graphql__WEBPACK_IMPORTED_MODULE_10__/* .useImperativeQuery */ .y)(_foros_fe_graphql__WEBPACK_IMPORTED_MODULE_9__/* .useRegistrationTypeQuery */ .FVq);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(registration), registrationView = ref1[0], setRegistrationView = ref1[1];
    var methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useForm */ .cI)({
        defaultValues: defaultValues
    });
    var executeRecaptcha = (0,react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_8__/* .useGoogleReCaptcha */ .xX)().executeRecaptcha;
    var register = methods.register, reset = methods.reset, setError = methods.setError, setFocus = methods.setFocus;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setFocus('email');
        setRegistrationView(registration);
    }, [
        registration,
        open,
        setFocus
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setFocus('email');
    }, [
        registrationView,
        setFocus
    ]);
    var handleClose = function() {
        reset(defaultValues);
        onClose();
    };
    var onSubmit = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var ref, ref2, recaptchaToken, ref3, apiData, error, leadUser, email, ref4, apiData1, registrationType;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!registrationView) {
                            _ctx.next = 18;
                            break;
                        }
                        ;
                        _ctx.next = 4;
                        return executeRecaptcha === null || executeRecaptcha === void 0 ? void 0 : executeRecaptcha('authentication');
                    case 4:
                        recaptchaToken = _ctx.sent;
                        _ctx.next = 7;
                        return createLeadUserMutation({
                            variables: {
                                input: {
                                    email: data.email,
                                    termsAndConditionsAccepted: data.terms,
                                    marketingConditionsAccepted: data.news,
                                    recaptchaToken: recaptchaToken
                                }
                            }
                        });
                    case 7:
                        ref3 = _ctx.sent;
                        apiData = ref3.data;
                        error = apiData === null || apiData === void 0 ? void 0 : (ref = apiData.createLeadUser) === null || ref === void 0 ? void 0 : ref.error;
                        leadUser = apiData === null || apiData === void 0 ? void 0 : (ref2 = apiData.createLeadUser) === null || ref2 === void 0 ? void 0 : ref2.leadUser;
                        if (!error) {
                            _ctx.next = 15;
                            break;
                        }
                        (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .setFormFieldsErrorTranslations */ .U5)(setError, error, {
                            email: 'CreateLeadUserEmailError'
                        });
                        (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .setFormFieldErrorTranslation */ .iX)(setError, 'terms', error.termsAndConditionsAccepted, 'CreateLeadUserTermsAndConditionsAcceptedError');
                        return _ctx.abrupt("return");
                    case 15:
                        sessionStorage.setItem(_config__WEBPACK_IMPORTED_MODULE_12__/* .leadUserKey */ .vR, JSON.stringify(leadUser));
                        _ctx.next = 33;
                        break;
                    case 18:
                        email = data.email;
                        _ctx.next = 21;
                        return registrationTypeQuery({
                            email: email
                        });
                    case 21:
                        ref4 = _ctx.sent;
                        apiData1 = ref4.data;
                        registrationType = apiData1 === null || apiData1 === void 0 ? void 0 : apiData1.userRegistrationType;
                        if (!(registrationType === _foros_fe_graphql__WEBPACK_IMPORTED_MODULE_9__/* .SignUpType.Lead */ .o_P.Lead)) {
                            _ctx.next = 28;
                            break;
                        }
                        return _ctx.abrupt("return", setRegistrationView(true));
                    case 28:
                        if (!(registrationType === _foros_fe_graphql__WEBPACK_IMPORTED_MODULE_9__/* .SignUpType.Authenticated */ .o_P.Authenticated)) {
                            _ctx.next = 32;
                            break;
                        }
                        {
                            sessionStorage.setItem(_config__WEBPACK_IMPORTED_MODULE_12__/* .emailKey */ .Ug, email);
                        }
                        _ctx.next = 33;
                        break;
                    case 32:
                        return _ctx.abrupt("return", setError('email', {
                            message: t('errors.emailUserDoesNotExist')
                        }));
                    case 33:
                        router.push({
                            pathname: registrationView ? '/sign-up' : '/sign-in'
                        });
                    case 34:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Modal__WEBPACK_IMPORTED_MODULE_13__/* .Modal */ .u, {
        open: open,
        onClose: handleClose,
        onExited: function() {
            return setRegistrationView(registration);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Forms_Form__WEBPACK_IMPORTED_MODULE_14__/* .Form */ .l, _objectSpread({}, methods, {
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                        children: registrationView ? t('createAccount') : t('logInToAccount')
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Inputs_TextInput__WEBPACK_IMPORTED_MODULE_15__/* .TextInput */ .o, _objectSpread({
                        label: t('email'),
                        className: "mb-6 min-w-[310px] md:min-w-[360px]"
                    }, register('email'))),
                    registrationView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Inputs_CheckBox__WEBPACK_IMPORTED_MODULE_16__/* .CheckBox */ .J, _objectSpread({
                                label: t('marketingAgreement'),
                                className: "mb-2"
                            }, register('news'))),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Inputs_CheckBox__WEBPACK_IMPORTED_MODULE_16__/* .CheckBox */ .J, _objectSpread({
                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                    children: [
                                        t('common:iAgreeWith'),
                                        ' ',
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                            href: "/rules",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NavLink, {
                                                children: t('nav.rules')
                                            })
                                        }),
                                        ' ',
                                        t('common:connectors.and'),
                                        ' ',
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                            href: "/privacy-policy",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NavLink, {
                                                children: t('nav.privacyPolicy')
                                            })
                                        })
                                    ]
                                }),
                                className: "mb-6"
                            }, register('terms')))
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_17__/* .Button */ .z, {
                        title: t('continue'),
                        value: registrationView ? 'register-modal' : 'login-modal',
                        className: "w-full mb-6",
                        type: "submit"
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                className: "text-center text-gray-800",
                children: [
                    registrationView ? t('haveAccount') : t('needAccount'),
                    "\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NavLink, {
                        onClick: function() {
                            return setRegistrationView(!registrationView);
                        },
                        children: registrationView ? t('common:nav.logIn') : t('common:nav.signUp')
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 97872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ CloseButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _SvgIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16283);
/* harmony import */ var _foros_fe_assets_icons_times_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60581);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  w-7\n  h-7\n  rounded\n  bg-transparent\n  hover:bg-gray-300\n  active:bg-gray-400\n  flex\n  items-center\n  justify-center\n  transition\n  duration-300\n  cursor-pointer\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject());
var CloseButton = function(props) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, _objectSpread({}, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SvgIcon__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l, {
            src: _foros_fe_assets_icons_times_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
            size: 16
        })
    })));
};


/***/ }),

/***/ 76008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ CheckBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63955);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ErrorMessages__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29371);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-col items-start"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  form-checkbox\n  appearance-none\n  h-5\n  w-5\n  border-2\n  border-secondary-500\n  hover:border-secondary-600\n  active:border-secondary-700\n  rounded-md\n  focus:text-secondary-500\n  hover:bg-transparent\n  checked:bg-secondary-500\n  indeterminate:bg-secondary-500\n  hover:checked:bg-secondary-600\n  active:checked:bg-secondary-700\n  hover:indeterminate:bg-secondary-600\n  active:indeterminate:bg-secondary-700\n  checked:border-transparent\n  disabled:border-gray-400\n  checked:disabled:bg-gray-400\n  focus:ring-transparent\n  transition\n  duration-300\n  cursor-pointer\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  text-sm\n  text-gray-700\n  cursor-pointer\n  flex\n  items-center\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().div(_templateObject());
var Input = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().input(_templateObject1());
var Label = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_3___default().label(_templateObject2());
var CheckBox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var name = _param.name, label = _param.label, error = _param.error, className = _param.className, _indeterminate = _param.indeterminate, indeterminate = _indeterminate === void 0 ? false : _indeterminate, props = _objectWithoutProperties(_param, [
        "name",
        "label",
        "error",
        "className",
        "indeterminate"
    ]);
    var context = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)();
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return inputRef.current;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [
        inputRef,
        indeterminate,
        props.checked
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, _objectSpread({
                        name: name,
                        type: "checkbox",
                        ref: inputRef
                    }, props)),
                    label ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            "\xa0",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: label
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorMessages__WEBPACK_IMPORTED_MODULE_4__/* .ErrorMessages */ .X, {
                error: error || (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2)(context === null || context === void 0 ? void 0 : context.formState.errors, name),
                className: "ml-5"
            })
        ]
    }));
});



/***/ }),

/***/ 27581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3404);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63964);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32345);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97872);
/* harmony import */ var _Card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28658);








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    z-index: 500;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  py-8\n  lg:px-6\n  border\n  border-gray-400\n  min-w-[360px]\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  absolute\n  top-[6px]\n  right-[6px]\n  md:top-[12px]\n  md:right-[12px]\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var StyledBackdrop = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    transitionDuration: 300
}).withConfig({
    componentId: "sc-7cc90a53-0"
})(_templateObject());
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default()(_Card__WEBPACK_IMPORTED_MODULE_5__/* .Card */ .Z)(_templateObject1());
var StyledClose = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default()(_CloseButton__WEBPACK_IMPORTED_MODULE_6__/* .CloseButton */ .P)(_templateObject2());
var Modal = function(_param) {
    var _open = _param.open, open = _open === void 0 ? false : _open, onClose = _param.onClose, _cardClassname = _param.cardClassname, cardClassname = _cardClassname === void 0 ? '' : _cardClassname, children = _param.children, props = _objectWithoutProperties(_param, [
        "open",
        "onClose",
        "cardClassname",
        "children"
    ]);
    var ref = (0,_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useScrollBlock */ .hZ)(), blockScroll = ref.blockScroll, allowScroll = ref.allowScroll;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (open) {
            blockScroll();
        } else {
            allowScroll();
        }
        return allowScroll;
    }, [
        open,
        allowScroll,
        blockScroll
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBackdrop, _objectSpread({
        open: open
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
            className: cardClassname,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledClose, {
                    onClick: function() {
                        return onClose === null || onClose === void 0 ? void 0 : onClose(!open);
                    }
                }),
                children
            ]
        })
    })));
};



/***/ }),

/***/ 42234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ NavBar; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63964);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../graphql/src/generated/index.ts + 11 modules
var generated = __webpack_require__(63575);
// EXTERNAL MODULE: ../core/src/hooks/index.ts
var hooks = __webpack_require__(32345);
// EXTERNAL MODULE: ../core/src/hooks/authentication.ts
var authentication = __webpack_require__(96172);
// EXTERNAL MODULE: ../core/src/components/Button.tsx
var Button = __webpack_require__(36573);
// EXTERNAL MODULE: ../core/src/components/AuthModal.tsx
var AuthModal = __webpack_require__(14264);
// EXTERNAL MODULE: ../../node_modules/hamburger-react/dist-esm/Squash.js + 1 modules
var Squash = __webpack_require__(94744);
// EXTERNAL MODULE: ../core/src/config/theme.js
var theme = __webpack_require__(46487);
var theme_default = /*#__PURE__*/__webpack_require__.n(theme);
;// CONCATENATED MODULE: ../core/src/components/Navigation/Burger.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Burger = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Squash/* Squash */.v, _objectSpread({
        color: (theme_default()).colors.gray[600],
        rounded: true
    }, props)));
};

// EXTERNAL MODULE: ../core/src/components/SvgIcon.tsx
var SvgIcon = __webpack_require__(16283);
// EXTERNAL MODULE: ../core/src/components/Popup.tsx
var Popup = __webpack_require__(13788);
;// CONCATENATED MODULE: ../core/src/components/Menu.tsx




function Menu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Menu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Menu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-col py-1 rounded w-[200px]"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  py-1\n  px-4\n  flex\n  flex-1\n  text-primary-500\n  font-medium\n  hover:bg-gray-300\n  hover:cursor-pointer\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Container = dist_default().div(_templateObject());
var Item = dist_default().p(_templateObject1());
var Menu = function(_param) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    var renderChildren = (0,react.useCallback)(function(close) {
        return typeof children === 'function' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: children(close)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: children
        });
    }, [
        children
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Popup/* Popup */.G, Menu_objectSpread({
        position: 'bottom right'
    }, props, {
        children: renderChildren
    })));
};

Menu.Item = Item;

;// CONCATENATED MODULE: ../assets/icons/profile.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.492 27c1.85 0 3.588-.351 5.216-1.054a13.646 13.646 0 0 0 4.305-2.927 13.949 13.949 0 0 0 2.925-4.316A12.91 12.91 0 0 0 27 13.5c0-1.84-.354-3.574-1.062-5.203a13.876 13.876 0 0 0-2.934-4.316 13.746 13.746 0 0 0-4.313-2.927C17.064.35 15.325 0 13.475 0c-1.84 0-3.572.351-5.2 1.054A13.549 13.549 0 0 0 3.98 3.98a14.019 14.019 0 0 0-2.917 4.316A12.91 12.91 0 0 0 0 13.5c0 1.84.354 3.574 1.062 5.203a13.947 13.947 0 0 0 2.925 4.316 13.647 13.647 0 0 0 4.305 2.927c1.627.703 3.36 1.054 5.2 1.054Zm0-2.543c-1.516 0-2.934-.281-4.255-.845a10.858 10.858 0 0 1-3.478-2.35 11.006 11.006 0 0 1-2.34-3.496c-.563-1.327-.844-2.75-.844-4.266A10.892 10.892 0 0 1 9.22 3.388c1.32-.564 2.74-.845 4.255-.845 1.527 0 2.95.281 4.271.845a10.955 10.955 0 0 1 3.486 2.35 11.054 11.054 0 0 1 2.358 3.496c.568 1.327.852 2.75.852 4.266 0 1.517-.281 2.939-.844 4.266a11.005 11.005 0 0 1-2.34 3.496 10.835 10.835 0 0 1-3.486 2.35c-1.327.564-2.753.845-4.28.845Zm9.01-2.258-.05-.167c-.2-.647-.702-1.28-1.504-1.9-.803-.618-1.839-1.128-3.11-1.53-1.27-.401-2.72-.602-4.346-.602-1.617 0-3.063.2-4.339.602-1.276.402-2.312.912-3.11 1.53-.796.62-1.295 1.253-1.496 1.9l-.05.167c.792.78 1.742 1.441 2.85 1.982 1.11.541 2.213.954 3.31 1.238 1.099.284 2.043.427 2.835.427.791 0 1.738-.143 2.842-.427a17.362 17.362 0 0 0 3.31-1.238c1.103-.54 2.056-1.201 2.859-1.982Zm-9.01-6.407c.847.011 1.61-.2 2.29-.636a4.7 4.7 0 0 0 1.622-1.773c.4-.747.602-1.595.602-2.543 0-.88-.201-1.69-.602-2.426a4.802 4.802 0 0 0-1.622-1.764 4.12 4.12 0 0 0-2.29-.661c-.836 0-1.597.22-2.282.66a4.777 4.777 0 0 0-1.63 1.765 4.853 4.853 0 0 0-.586 2.426c0 .948.201 1.793.602 2.534a4.65 4.65 0 0 0 1.622 1.757c.68.43 1.438.65 2.274.66Z",
    fill: "#346775"
  })));
};

/* harmony default export */ var profile = (SvgProfile);
;// CONCATENATED MODULE: ../core/src/components/ProfileMenu.tsx







var ProfileMenu = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var logout = (0,authentication/* useLogout */.aU)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-[27px] h-[27px] flex items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                src: profile,
                size: 27,
                className: "cursor-pointer"
            })
        }),
        position: 'bottom right',
        children: function(close) {
            var onClick = function() {
                logout();
                close();
            };
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/settings",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                            children: t('nav.settings')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                        onClick: onClick,
                        children: t('nav.logout')
                    })
                ]
            }));
        }
    }));
};

// EXTERNAL MODULE: ../core/src/config/domains.js
var domains = __webpack_require__(2811);
var domains_default = /*#__PURE__*/__webpack_require__.n(domains);
// EXTERNAL MODULE: ../core/src/config/api.js
var api = __webpack_require__(91673);
var api_default = /*#__PURE__*/__webpack_require__.n(api);
// EXTERNAL MODULE: ../assets/icons/foros-logo.svg
var foros_logo = __webpack_require__(41516);
;// CONCATENATED MODULE: ../assets/images/ma-logo.png
/* harmony default export */ var ma_logo = ({"src":"/_next/static/media/ma-logo.8377861e.png","height":314,"width":1234,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEUhSFgJPV0KPVxXaEgAMGKY5DM1AAAABXRSTlMISzIzG+fvD24AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAWSURBVAiZY2BgYGIAA0ZGRkYmFmZmAABnABMmgQYjAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/icons/phone.svg
var phone_path;

function phone_extends() { phone_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_extends.apply(this, arguments); }



var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/react.createElement("svg", phone_extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), phone_path || (phone_path = /*#__PURE__*/react.createElement("path", {
    d: "M18.24 14.1v2.5a1.665 1.665 0 0 1-1.816 1.667 16.492 16.492 0 0 1-7.192-2.558 16.25 16.25 0 0 1-5-5 16.492 16.492 0 0 1-2.558-7.226 1.667 1.667 0 0 1 1.658-1.816h2.5A1.667 1.667 0 0 1 7.5 3.1c.105.8.301 1.586.583 2.342A1.667 1.667 0 0 1 7.707 7.2L6.65 8.258a13.333 13.333 0 0 0 5 5l1.058-1.058a1.667 1.667 0 0 1 1.758-.375 10.7 10.7 0 0 0 2.342.584A1.667 1.667 0 0 1 18.24 14.1Z",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ var phone = (SvgPhone);
;// CONCATENATED MODULE: ../assets/icons/document.svg
var document_path, _path2;

function document_extends() { document_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return document_extends.apply(this, arguments); }



var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/react.createElement("svg", document_extends({
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), document_path || (document_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 1H2.8A1.8 1.8 0 0 0 1 2.8v14.4A1.8 1.8 0 0 0 2.8 19h10.8a1.8 1.8 0 0 0 1.8-1.8V6.4L10 1Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M10 1v5.4h5.4M8.2 15.4V10M5.5 12.7h5.4",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ var icons_document = (SvgDocument);
;// CONCATENATED MODULE: ../core/src/components/Navigation/NavBar.tsx




















function NavBar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NavBar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NavBar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function NavBar_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = NavBar_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function NavBar_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function NavBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NavBar_templateObject() {
    var data = NavBar_taggedTemplateLiteral([
        "bg-primary-500 h-9 w-[100%] flex"
    ]);
    NavBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavBar_templateObject1() {
    var data = NavBar_taggedTemplateLiteral([
        "ml-2 text-white text-sm font-semibold"
    ]);
    NavBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = NavBar_taggedTemplateLiteral([
        "filter border-b border-gray-300 bg-white h-[68px] flex"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = NavBar_taggedTemplateLiteral([
        "\n  container\n  flex\n  flex-1\n  items-center\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = NavBar_taggedTemplateLiteral([
        "hidden md:block lg:flex lg:flex-1"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = NavBar_taggedTemplateLiteral([
        "md:hidden"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = NavBar_taggedTemplateLiteral([
        "\n  text-lg\n  md:text-base\n  text-primary-500\n  font-medium\n  cursor-pointer\n  transition-all\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = NavBar_taggedTemplateLiteral([
        "\n  mb-2\n  lg:mb-0\n  md:relative\n  md:inline-block\n  lg:flex\n  lg:items-center\n  top-1/2\n  -translate-y-1/2\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = NavBar_taggedTemplateLiteral([
        "\n  &:after {\n    content: '';\n    position: absolute;\n    height: 4px;\n    background-color: ",
        ";\n  }\n  @media (min-width: 768px) {\n    &:after {\n      bottom: -22px;\n      left: 0;\n      right: 0;\n    }\n  }\n  @media (min-width: 1152px) {\n    &:after {\n      bottom: 0;\n      left: 0;\n      right: 0;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = NavBar_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  transition-all\n  duration-500\n  ease-out\n  absolute\n  bg-white\n  bg-opacity-100\n  bottom-0\n  left-0\n  right-0\n  flex\n  flex-col\n  pt-5\n  px-2\n  text-2xl\n  z-[500]\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
var BlueBar = dist_default().div(NavBar_templateObject());
var BlueBarText = dist_default().p(NavBar_templateObject1());
var TopContainer = dist_default().div(_templateObject2());
var NavBar_Container = dist_default().div(_templateObject3());
var DesktopBlock = dist_default().div(_templateObject4());
var MobileBlock = dist_default().div(_templateObject5());
var LogInAnchor = dist_default().a(_templateObject6());
var TwAnchor = dist_default()(LogInAnchor)(_templateObject7());
var Anchor = (0,styled_components_browser_esm/* default */.ZP)(TwAnchor).withConfig({
    componentId: "sc-b73fa47a-0"
})(_templateObject8(), function(param) {
    var $active = param.$active;
    return $active ? (theme_default()).colors.secondary[500] : (theme_default()).colors.transparent;
});
var ResponsiveMenu = dist_default().div(_templateObject9(), function(param) {
    var $open = param.$open;
    return $open ? 'visible' : 'invisible';
}, function(param) {
    var $open = param.$open;
    return $open ? 'opacity-1' : 'opacity-0';
});
var NavLink = function(_param) {
    var href = _param.href, props = NavBar_objectWithoutProperties(_param, [
        "href"
    ]);
    var pathname = (0,router.useRouter)().pathname;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, NavBar_objectSpread({
            $active: pathname.includes(href.toString())
        }, props))
    }));
};
var Logo = function() {
    switch((domains_default()).current.name){
        case 'miskoaukcionas.lt':
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                src: ma_logo,
                width: 176.844,
                height: 45
            }));
        default:
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                src: foros_logo/* default */.Z,
                width: 100,
                height: 24
            }));
    }
};
var consultationPhoneNumber = (domains_default()).current.consultationPhoneNumber;
var LeadInquiryBar = function() {
    var t = (0,esm/* useTranslation */.$G)('common').t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(BlueBar, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBar_Container, {
            className: "justify-center md:justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "tel:".concat(consultationPhoneNumber),
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                            src: phone,
                            size: 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlueBarText, {
                            className: "hidden md:block",
                            children: t('freeConsultation')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlueBarText, {
                            children: consultationPhoneNumber
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/auctions/inquiry",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "hidden md:flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                src: icons_document,
                                width: 17,
                                height: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlueBarText, {
                                children: t('freeAuctionStart')
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
var NavBar = function() {
    var t = (0,esm/* useTranslation */.$G)('common').t;
    var ref = (0,react.useState)(false), responsiveMenuOpen = ref[0], toggleResponsiveMenu = ref[1];
    var ref1 = (0,react.useState)(false), authOpen = ref1[0], setAuthOpened = ref1[1];
    var ref2 = (0,react.useState)(false), registration = ref2[0], setRegistration = ref2[1];
    var ref3 = (0,hooks/* useScrollBlock */.hZ)(), blockScroll = ref3.blockScroll, allowScroll = ref3.allowScroll;
    var data = (0,generated/* useCurrentUserQuery */.rkO)().data;
    var logout = (0,authentication/* useLogout */.aU)();
    (0,react.useEffect)(function() {
        if (responsiveMenuOpen) {
            blockScroll();
        } else {
            allowScroll();
        }
        return allowScroll;
    }, [
        responsiveMenuOpen,
        allowScroll,
        blockScroll
    ]);
    var openLogin = function() {
        toggleResponsiveMenu(false);
        setRegistration(false);
        setAuthOpened(!authOpen);
    };
    var openRegistration = function() {
        toggleResponsiveMenu(false);
        setRegistration(true);
        setAuthOpened(!authOpen);
    };
    var openAdmin = function() {
        return window.location.href = (api_default()).adminURL;
    };
    var logoutOnClick = function() {
        logout();
        toggleResponsiveMenu(false);
    };
    var dashboardEnabled = (domains_default()).current.name !== 'foros.lv';
    var user = data === null || data === void 0 ? void 0 : data.currentUser;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "z-50",
        children: [
            user ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadInquiryBar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBar_Container, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: user && dashboardEnabled ? '/dashboard' : '/',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "flex flex-1 items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBlock, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Burger, {
                                toggled: responsiveMenuOpen,
                                toggle: toggleResponsiveMenu
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopBlock, {
                            className: "h-full md:space-x-4 lg:space-x-8 xs:mr-0 md:mr-4 lg:mr-0 justify-center",
                            children: [
                                user && dashboardEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                                    href: "/dashboard",
                                    children: t('nav.dashboard')
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                                    href: "/auctions",
                                    children: t('nav.auctions')
                                }),
                                user ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                                    href: "/about-us",
                                    children: t('nav.aboutUs')
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                                    href: "/contact-us",
                                    children: t('nav.contactUs')
                                }),
                                (user === null || user === void 0 ? void 0 : user.isEmployee) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
                                    onClick: openAdmin,
                                    children: t('nav.admin')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopBlock, {
                            className: "md:pl-4 lg:pl-0 md:border-l-2 lg:border-0 md:flex justify-end items-center",
                            children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogInAnchor, {
                                        onClick: openLogin,
                                        children: t('nav.logIn')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        value: "nav-sign-up",
                                        title: t('nav.signUpFree'),
                                        className: "ml-4",
                                        onClick: openRegistration
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal/* AuthModal */.Q, {
                registration: registration,
                open: authOpen,
                onClose: function() {
                    return setAuthOpened(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveMenu, {
                $open: responsiveMenuOpen,
                className: user ? 'top-[68px]' : 'top-[104px]',
                children: [
                    user ? dashboardEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                        href: "/dashboard",
                        children: t('nav.dashboard')
                    }) : null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
                        onClick: openLogin,
                        children: t('nav.logIn')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                        href: "/auctions",
                        children: t('nav.auctions')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                        href: "/about-us",
                        children: t('nav.aboutUs')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                        href: "/contact-us",
                        children: t('nav.contactUs')
                    }),
                    (user === null || user === void 0 ? void 0 : user.isEmployee) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
                        onClick: openAdmin,
                        children: t('nav.admin')
                    }),
                    user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                                href: "/settings",
                                children: t('nav.settings')
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
                                onClick: logoutOnClick,
                                children: t('nav.logout')
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        value: "nav-sign-up",
                        title: t('nav.signUpFree'),
                        className: "text-xl self-start",
                        onClick: openRegistration
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 13788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ Popup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var reactjs_popup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86776);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63964);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_3__);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  &-content {\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    box-sizing: border-box;\n    border-radius: 5px;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.06),\n      0px 0px 1px rgba(0, 0, 0, 0.04);\n  }\n  &-arrow {\n    color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPopup = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(reactjs_popup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d4ec2161-0"
})(_templateObject(), (_config__WEBPACK_IMPORTED_MODULE_3___default().colors.white), (_config__WEBPACK_IMPORTED_MODULE_3___default().colors.gray[400]));
var Popup = function(props) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledPopup, _objectSpread({
        position: 'bottom left',
        keepTooltipInside: true,
        closeOnDocumentClick: true
    }, props)));
};


/***/ }),

/***/ 32345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mL": function() { return /* binding */ useDeviceMediaQuery; },
/* harmony export */   "hZ": function() { return /* binding */ useScrollBlock; },
/* harmony export */   "$o": function() { return /* binding */ useDateTimeDuration; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17160);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75920);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96299);






function useDeviceMediaQuery() {
    return {
        mobile: (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
            query: "(max-width: ".concat(parseInt((_config__WEBPACK_IMPORTED_MODULE_2___default().screens.md)) - 1, "px)")
        }),
        tablet: (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
            query: "(min-width: ".concat(parseInt((_config__WEBPACK_IMPORTED_MODULE_2___default().screens.md)), "px) and (max-width: ").concat(parseInt((_config__WEBPACK_IMPORTED_MODULE_2___default().screens.lg)) - 1, "px)")
        }),
        desktop: (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
            query: "(min-width: ".concat(parseInt((_config__WEBPACK_IMPORTED_MODULE_2___default().screens.lg)), "px)")
        })
    };
}
var useScrollBlock = function() {
    var scrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var blockScroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (typeof scrollPosition.current === 'number') return;
        scrollPosition.current = window.scrollY;
        var body = document.body;
        body.style.inset = "-".concat(scrollPosition.current, "px 0px 0px");
        body.style.position = 'fixed';
    }, [
        scrollPosition
    ]);
    var allowScroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (typeof scrollPosition.current !== 'number') return;
        var body = document.body;
        body.style.inset = 'initial';
        body.style.position = 'initial';
        window.scrollTo(0, scrollPosition.current);
        scrollPosition.current = null;
    }, [
        scrollPosition
    ]);
    return {
        blockScroll: blockScroll,
        allowScroll: allowScroll
    };
};
function useDateTimeDuration(endTime) {
    var active = endTime && luxon__WEBPACK_IMPORTED_MODULE_3__/* .DateTime.fromISO */ .ou.fromISO(endTime) > luxon__WEBPACK_IMPORTED_MODULE_3__/* .DateTime.local */ .ou.local();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(active ? (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .humanDurationString */ .j2)(endTime) : ''), timeLeft = ref[0], setTimeLeft = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (active) {
            var intervalID = setInterval(function() {
                return setTimeLeft((0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .humanDurationString */ .j2)(endTime));
            }, 1000);
            return function() {
                return clearInterval(intervalID);
            };
        }
    }, [
        active,
        endTime
    ]);
    return timeLeft;
}


/***/ }),

/***/ 33627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ usePaginatedQuery; },
/* harmony export */   "y": function() { return /* binding */ useImperativeQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var usePaginatedQuery = function(useQuery, options, resourceName) {
    var ref;
    var _ref = useQuery(options), fetchMore = _ref.fetchMore, data1 = _ref.data, result = _objectWithoutProperties(_ref, [
        "fetchMore",
        "data"
    ]);
    var getResource = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(data) {
        return data === null || data === void 0 ? void 0 : data[resourceName];
    }, [
        resourceName
    ]);
    var pageInfo = (ref = getResource(data1)) === null || ref === void 0 ? void 0 : ref.pageInfo;
    var after = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor;
    var hasNextPage = !!(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage);
    var loadMoreResults = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(variables) {
        return fetchMore({
            variables: _objectSpread({}, variables, {
                after: after
            })
        });
    }, [
        fetchMore,
        after
    ]);
    return _objectSpread({}, result, {
        data: data1,
        fetchMore: loadMoreResults,
        hasNextPage: hasNextPage
    });
};

var useImperativeQuery = function(useQuery) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var refetch = useQuery(_objectSpread({}, options, {
        skip: true
    })).refetch;
    return function(variables) {
        return refetch(variables);
    };
};


/***/ })

}]);